import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import VirtualVideoTest from './index';
import { testCallActions } from '../../redux/healthboard/test-call';
import {
  selectTestCallModalOpened,
  selectTestCallModalProps,
} from '../../redux/healthboard/selectors';

function VirtualTestCallModal() {
  const opened = useSelector(selectTestCallModalOpened);
  const props = useSelector(selectTestCallModalProps);
  const dispatch = useDispatch();

  const close = () => dispatch(testCallActions.close());

  if (!opened) return null;

  return <VirtualVideoTest onClose={close} {...props} />;
}

export default VirtualTestCallModal;



// WEBPACK FOOTER //
// ./src/components/VirtualVideoTest/VirtualTestCallModal.jsx